import { Text, Box } from "theme-ui";
import * as styles from "./ColorPickerToolTip.styles";

export default function ColorPickerToolTip({ backgroundColor, children }) {
  return (
    <Box sx={styles.colorPickerToolTip}>
      <Text variant="copy3Light">{children}</Text>
      <Box sx={styles.colorPickerIcon(backgroundColor)}></Box>
    </Box>
  );
}
